import {CurrencySettings} from "@/extensions/services/currency-settings";

export const getCurrencySettings = (currency) => {
    return CurrencySettings[currency] || CurrencySettings["default"];
}

export const getCurrencySymbol = (currency) => {
    const settings = getCurrencySettings(currency);

    if (typeof settings.symbol !== 'undefined') return settings.symbol;

    return currency;
}
